import { useMainSelector } from '../../useMainSelector';

export const useLabels = () => {
  const {
    settings: { labels, selectedLabel },
  } = useMainSelector();

  return { labels, selectedLabel };
};
